module.exports = __webpack_public_path__ + "static/img/contract3.bf080f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/contract3.png
// module id = ZiCG
// module chunks = 1